import { SvgIcon } from '@mui/material'

export default function LinkTasksIcon() {
  return (
    <SvgIcon sx={{ width: 20, height: 20 }}>
      <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <title>Link Tasks</title>
        <path
          d='M12.08 1.66699H7.91333C7.22298 1.66699 6.66333 2.22664 6.66333 2.91699C6.66333 3.60735 7.22298 4.16699 7.91333 4.16699H12.08C12.7703 4.16699 13.33 3.60735 13.33 2.91699C13.33 2.22664 12.7703 1.66699 12.08 1.66699Z'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.66333 12.5003H9.52051M6.66333 9.16699H13.33'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.3301 2.91699C14.6247 2.95601 15.3968 3.10039 15.9312 3.6348C16.6634 4.36703 16.6634 5.54553 16.6634 7.90252V13.3332C16.6634 15.6903 16.6634 16.8688 15.9312 17.601C15.1989 18.3332 14.0204 18.3332 11.6634 18.3332H8.33008C5.97306 18.3332 4.79455 18.3332 4.06232 17.601C3.33009 16.8688 3.33009 15.6903 3.33008 13.3333L3.33009 7.90257C3.33009 5.54554 3.33009 4.36703 4.06232 3.63479C4.59672 3.10038 5.36884 2.956 6.66333 2.91699'
          stroke='#153CB7'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </SvgIcon>
  )
}
